var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('b', [_vm._v("Edit RM Approval Pending")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.$emit('prevPage')
      }
    }
  }, [_vm._v("Back")])]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "AWB Number :",
      "description": ""
    }
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-book'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbnumberObject.awbnumber),
      expression: "awbnumberObject.awbnumber"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "awbnumber",
      "name": "awbnumber",
      "disabled": _vm.disableFields,
      "type": "text"
    },
    domProps: {
      "value": (_vm.awbnumberObject.awbnumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awbnumberObject.awbnumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('b-input-group-button', {
    slot: "right"
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', {
    attrs: {
      "name": "takeActionn",
      "label": "Take Action: <span style='color: red'>*</span> ",
      "label-cols": 2,
      "horizontal": true
    }
  }, [_c('div', {
    staticClass: "takeActionRadio"
  }, _vm._l((_vm.takeactionlist), function(n, index) {
    return _c('div', {
      key: index,
      staticClass: "takeactionradiobtns",
      staticStyle: {
        "padding-right": "2.5%"
      },
      on: {
        "change": function($event) {
          _vm.selectData(n.id, n.label)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.takeActionname),
        expression: "takeActionname"
      }],
      attrs: {
        "type": "radio",
        "name": n.label
      },
      domProps: {
        "value": n.id,
        "checked": _vm._q(_vm.takeActionname, n.id)
      },
      on: {
        "__c": function($event) {
          _vm.takeActionname = n.id
        }
      }
    }), _vm._v("\n                  " + _vm._s(n.label) + "\n                ")])
  }))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group-row image-upload"
  }, [_c('label', {
    attrs: {
      "for": "upload"
    }
  }, [_vm._v("Upload images or videos")]), _vm._v(" "), _c('b-input-group', {
    staticClass: "imageUploadClass"
  }, [_c('input', {
    attrs: {
      "id": "upload",
      "type": "file",
      "multiple": "multiple"
    },
    on: {
      "change": function($event) {
        _vm.onImageFileChange($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imageGroup"
  }, _vm._l((_vm.images), function(image, index) {
    return _c('div', {
      key: index,
      staticClass: "image-view-upload row"
    }, [_c('img', {
      staticClass: "col-md-offset-1 col-md-2 col-sm-3 col-xs-4",
      attrs: {
        "src": image.url,
        "onerror": "this.src='static/img/vp.svg';"
      },
      on: {
        "click": function($event) {
          _vm.downloadImage(image)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          _vm.removeImage(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      staticStyle: {
        "font-size": "25px"
      }
    })])])
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row static-images"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', [_vm._v("Media uploaded by executive:")]), _vm._v(" "), _c('div', {
    key: "index",
    staticClass: "media-item"
  }, [_vm._l((_vm.assetsByExecutive), function(img, index) {
    return [_c('img', {
      key: index,
      staticClass: "image-preview",
      attrs: {
        "src": img.path,
        "alt": "Image Preview",
        "onerror": "this.src='static/img/vp.svg';"
      },
      on: {
        "click": function($event) {
          _vm.showImage(img)
        }
      }
    })]
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', [_vm._v("Images/Video uploaded by client:")]), _vm._v(" "), _vm._l((_vm.assetsClient), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "media-container"
    }, [_c('div', {
      staticClass: "image-container"
    }, [_vm._l((_vm.clientImages), function(img) {
      return [(img.attachment) ? [(_vm.isGoogleDriveLink(img.attachment)) ? _c('iframe', {
        staticClass: "media image-preview",
        attrs: {
          "src": _vm.convertToEmbedUrl(img.attachment),
          "frameborder": "0",
          "allowfullscreen": ""
        }
      }) : _c('img', {
        staticClass: "image-preview",
        attrs: {
          "src": img.attachment,
          "alt": "Image Preview",
          "onerror": "this.src='static/img/img-ph.png';"
        },
        on: {
          "click": function($event) {
            _vm.showMediaOfImage(img.attachment)
          }
        }
      })] : _vm._e()]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "video-container"
    }, [_vm._l((item.vediourl), function(vid) {
      return _c('div', {
        key: vid.UnboxingVideoProof1
      }, [(vid.UnboxingVideoProof1) ? [(_vm.isGoogleDriveLink(vid.UnboxingVideoProof1)) ? _c('iframe', {
        staticClass: "media video-preview",
        attrs: {
          "src": _vm.convertToEmbedUrl(vid.UnboxingVideoProof1),
          "frameborder": "0",
          "allowfullscreen": ""
        }
      }) : _c('video', {
        staticClass: "video-preview",
        attrs: {
          "src": vid.UnboxingVideoProof1,
          "controls": ""
        }
      }, [_vm._v("\n                    Your browser does not support the video tag.\n                  ")])] : _vm._e()], 2)
    }), _vm._v(" "), _c('div', {
      staticClass: "download-button"
    }, [_c('button', {
      on: {
        "click": function($event) {
          _vm.downloadVideo(_vm.vid.UnboxingVideoProof1)
        }
      }
    }, [_vm._v("\n                    Download Video\n                  ")])])], 2)])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Description :")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "name": "description",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('b-button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('updateDetails', _vm.awbnumberObject.awbnumber, _vm.takeactionid, _vm.description, _vm.uploadImageQueue())
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" "), _c('span', [_vm._v("Submit")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_vm._v(" Reset "), _c('i', {
    staticClass: "fa fa-refresh"
  })])], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "imgPopUp",
      "title": "BootstrapVue"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('b-card', {
    class: (_vm.Isvideo) ? 'card-body-width' : ''
  }, [_c('span', {
    staticClass: "download-btn"
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.imgData,
      "download": ""
    }
  }, [_vm._v("Download")])]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.closeImage()
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), (!_vm.Isvideo) ? _c('img', {
    attrs: {
      "src": _vm.imgData,
      "alt": "loading..."
    }
  }) : _vm._e(), _vm._v(" "), (_vm.Isvideo) ? _c('video', {
    ref: "videoPlayer",
    attrs: {
      "controls": ""
    }
  }) : _vm._e()])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ee1a576","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/B2B components/editComponentOfRMApproval.vue
// module id = 621
// module chunks = 1